import { render, staticRenderFns } from "./ConcessionsList.vue?vue&type=template&id=c253f75e&"
import script from "./ConcessionsList.vue?vue&type=script&lang=js&"
export * from "./ConcessionsList.vue?vue&type=script&lang=js&"
import style0 from "./ConcessionsList.vue?vue&type=style&index=0&id=c253f75e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports